
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/start-here",
      function () {
        return require("private-next-pages/docs/start-here/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/start-here"])
      });
    }
  